let autocompleteAutofocusHook = {
  mounted() {
    const emailInput = this.el.querySelector('input[type="email"]')
    emailInput.focus()
    preventTabFromFocusingNextField(emailInput)
    this.handleEvent("autocompleted", (msg) => {
      if (this.el.dataset.index == msg.index) {
        const form = document.getElementById("multiple-contacts-form")
          ? document.getElementById("multiple-contacts-form")
          : document.getElementById("contacts_form_modal")

        const firstNotFilledInput = findNextEmptyInput(form)
        firstNotFilledInput.focus()
      }
    })
  },
}

// This function is needed because:
// "The JavaScript client is always the source of truth for current input values.
// For any given input with focus, LiveView will never overwrite the input's current value,
// even if it deviates from the server's rendered updates"
// - https://hexdocs.pm/phoenix_live_view/0.3.1/Phoenix.LiveView.html#module-forms-and-input-handling
// So while an input is focused, it's value cannot be changed from the server
// and will remain blank
function preventTabFromFocusingNextField(input) {
  input.addEventListener("keydown", (e) => {
    if (e.key == "Tab") {
      e.preventDefault()
      input.blur()
    }
  })
}

function findNextEmptyInput(form) {
  var inputs = form.getElementsByTagName("input")

  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].value === "") {
      return inputs[i]
    }
  }

  return null // If no empty input found
}
export { autocompleteAutofocusHook }
